/**
 * MFEBoundary — React class-based error boundary.
 * Wraps each micro frontend so one crashing component
 * never takes down the entire shell.
 */
import React from 'react'
import MFEBus from './MFEBus'
import { mfeRegistry } from './MFERegistry'

class MFEBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null } }

  static getDerivedStateFromError(e) { return { err: e } }

  componentDidCatch(e) {
    MFEBus.emit('mfe:error', { name: this.props.name, message: e.message })
    const rec = mfeRegistry.get(this.props.name)
    if (rec) { rec.status = 'error'; mfeRegistry.set(this.props.name, rec) }
  }

  retry = () => this.setState({ err: null })

  render() {
    if (this.state.err) {
      return (
        <div style={{
          padding: '2rem', textAlign: 'center', color: '#fca5a5',
          border: '1px solid rgba(239,68,68,.3)', borderRadius: '18px',
          background: 'rgba(239,68,68,.05)', margin: '0 0 1.5rem',
        }}>
          <div style={{ fontSize: '1.4rem', marginBottom: '.5rem' }}>⚠️</div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: '.75rem', color: 'var(--cy)', marginBottom: '.35rem' }}>
            {this.props.name} · v{this.props.version}
          </div>
          <div style={{ fontSize: '.82rem', color: '#fca5a5', opacity: 0.8 }}>
            {this.state.err.message || 'Micro frontend failed to render'}
          </div>
          <button onClick={this.retry} style={{
            marginTop: '1rem', padding: '.4rem 1rem', borderRadius: '8px',
            background: 'rgba(239,68,68,.12)', border: '1px solid rgba(239,68,68,.3)',
            color: '#fca5a5', cursor: 'pointer', fontFamily: 'var(--mono)', fontSize: '.72rem',
          }}>
            ↺ Retry
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default MFEBoundary
